import { useQuery } from "@tanstack/react-query";
import solanaTokens from "@/token/solana.json";
import type { TokenBalanceMap } from "@/hooks/useBalance";
import type { ApiToken } from "@/types";
import { getTokenColor } from "@/lib/utils";
import type { Token } from "@/types";

interface StaticToken {
	address: string;
	chainId?: number;
	decimals: number;
	name: string;
	symbol: string;
	logoURI?: string;
	logoUri?: string;
	coingeckoId?: string;
	usd_market_cap?: number;
	usd_24h_vol?: number;
	usd?: number;
	extensions?: {
		coingeckoId?: string;
	};
}

const STATIC_TOKENS: ApiToken[] = (solanaTokens as StaticToken[]).map((token) => ({
	address: token.address,
	chainId: token.chainId ?? 1,
	decimals: token.decimals,
	name: token.name,
	symbol: token.symbol,
	logoURI: token.logoURI ?? token.logoUri ?? "",
	coingeckoId: token.coingeckoId ?? token.extensions?.coingeckoId ?? "",
	usd_market_cap: token.usd_market_cap ?? 0,
	usd_24h_vol: token.usd_24h_vol ?? 0,
	usd: token.usd ?? 0,
}));

export function useTokenList() {
	return useQuery({
		queryKey: ["tokenList"],
		queryFn: () => STATIC_TOKENS,
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
		retry: false,
	});
}

export function mergeTokensWithBalances(
	tokens: ApiToken[],
	balances: TokenBalanceMap,
): Token[] {
	return tokens.map((t) => {
		const tokenBalance = balances[t.address];
		const balance = tokenBalance?.balance ?? 0;
		const fallbackPrice = Number(t.usd) || 0;
		const price = tokenBalance?.pricePerToken ?? fallbackPrice;
		const balanceUsd = tokenBalance?.usdValue ?? balance * price;

		return {
			...t,
			usd: price,
			balance,
			balanceUsd,
			color: getTokenColor(t.symbol),
		};
	});
}
